import { dateOf, esc } from './sbchart.ts';
type Ref = {kind: 'person' | 'firm' | 'bank' | 'gov'; id?: number; name: string};
type Origin = {schema: 'company-origin-v1'; day: number; founder: Ref; initialShares: number | null;
  capital: {kind: 'paid' | 'opening-bank-balance'; fen: string; to: Ref} | null};
type Row = (label: string, value: string) => string;
const object = (v: unknown): Record<string, unknown> | null => v != null && typeof v === 'object' && !Array.isArray(v) ? v as Record<string, unknown> : null;
const id = (v: unknown): v is number => typeof v === 'number' && Number.isSafeInteger(v) && v >= 0 && v <= 0xffffffff;
const ref = (v: unknown): v is Ref => {
  const r = object(v);
  return !!r && ['person', 'firm', 'bank', 'gov'].includes(r.kind as string) && typeof r.name === 'string' && (r.kind === 'gov' || id(r.id));
};
function origin(value: unknown): Origin | null {
  const o = object(value);
  return o?.schema === 'company-origin-v1' && id(o.day) && ref(o.founder) ? o as Origin : null;
}
function capital(o: Origin): Origin['capital'] {
  const c = object(o.capital);
  return c && ['paid', 'opening-bank-balance'].includes(c.kind as string) && typeof c.fen === 'string' && /^\d{1,19}$/.test(c.fen) && BigInt(c.fen) <= 9223372036854775807n && ref(c.to) ? c as NonNullable<Origin['capital']> : null;
}
const amount = (fen: string) => { const n = BigInt(fen); return `${(n / 100n).toLocaleString('en-US')}.${(n % 100n).toString().padStart(2, '0')} 元`; };
const shares = (v: unknown) => typeof v === 'number' && Number.isFinite(v) && v >= 0 ? `${v.toLocaleString('en-US', {maximumFractionDigits: 20})} 股` : '未记录';
const reference = (r: Ref) => `${r.name}${r.kind === 'gov' ? '' : ` · ${{person: '居民', firm: '公司', bank: '银行'}[r.kind]} #${r.id}`}`;

/** 旧payload缺记录就保持未知；不能使用当前boss或股东补填。 */
export function companyOriginHTML(value: unknown, row: Row, who: (r: Ref) => string): string {
  const o = origin(value);
  if (!o) return row('创立来源', '未记录');
  const c = capital(o);
  return row('创立者', who(o.founder)) + row('成立日', esc(dateOf(o.day))) +
    row(c?.kind === 'opening-bank-balance' ? '开局银行资本' : '成立实付', c ? amount(c.fen) : '未记录') +
    (c ? row(c.kind === 'paid' ? '出资到账' : '资本账户', who(c.to)) : '') + row('初始股份', shares(o.initialShares));
}

export function companyOriginText(value: unknown): string[] {
  const o = origin(value);
  if (!o) return ['创立来源：未记录'];
  const c = capital(o);
  return [`创立者：${reference(o.founder)}`, `成立日：${dateOf(o.day)}`, `初始股份：${shares(o.initialShares)}`,
    c ? `${c.kind === 'paid' ? '成立实付' : '开局银行资本'}：${amount(c.fen)} · ${reference(c.to)}` : '成立实付：未记录'];
}
